<template>
  <div class="users">
    <div class="top d-flex justify-content-between align-items-center">
      <transition name="slide-fade">
        <h1 class="mb-0" v-if="showTitle">{{msg}}</h1>
      </transition>
      <ul class="mb-0">
        <li class="list-inline-item">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            round
            v-b-modal.nuevoUsuarioModal
          >Nuevo usuario</el-button>
        </li>
      </ul>
    </div>
    <el-alert class="mt-3" :title="desc" type="info" :closable="false"></el-alert>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-bordered mt-3" v-loading="loadingUsers">
        <thead class="thead-dark">
          <tr>
            <th @click="getUsers('id')">
              Id
              <i
                class="fa float-right fa-sort"
                :class="{'fa-sort-up': sortDir == 'asc' && currentField == 'id', 'fa-sort-down': sortDir == 'desc' && currentField == 'id'}"
              ></i>
            </th>
            <th @click="getUsers('phone')">
              Teléfono
              <i
                class="fa float-right fa-sort"
                :class="{'fa-sort-up': sortDir == 'asc' && currentField == 'phone', 'fa-sort-down': sortDir == 'desc' && currentField == 'phone'}"
              ></i>
            </th>
            <th>Rol</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in usuarios" :key="usuario.id">
            <td>{{usuario.id}}</td>
            <td>{{usuario.phone}}</td>
            <td>
              <el-tag
                size="small"
                class="ml-1"
                v-for="rol in usuario.rolesList"
                :key="rol.index"
              >{{rol.name}}</el-tag>
            </td>
            <td>
              <span class title="Editar" @click="getUserInfo(usuario.id)">
                <el-button type="warning" size="mini" icon="el-icon-edit"></el-button>
              </span>
              <span class title="Reiniciar contador SMS" @click="resetSMS(usuario.phone)">
                <el-button type="success" size="mini" icon="el-icon-refresh"></el-button>
              </span>
              <span class title="Borrar" @click="deleteModal(usuario.id)">
                <el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <el-pagination
          v-if="totalPages > 1"
          @current-change="getUsers()"
          layout="prev, pager, next"
          :page-size="perPage"
          :current-page.sync="currentPage"
          :total="totalRows"
        ></el-pagination>
      </div>
    </div>

    <b-modal ref="myModalRef" id="nuevoUsuarioModal" title="Añadir nuevo usuario" @ok="btnAddUser">
      <form @submit.prevent="showModal = false">
        <b-form-group label="Teléfono*">
          <b-form-input
            type="number"
            required
            v-model="inputPhone"
            v-bind:class="{ 'is-invalid': attemptSubmit && missingPhone }"
          ></b-form-input>
          <div class="invalid-feedback">Campo obligatorio</div>
        </b-form-group>
        <b-form-group label="Roles*">
          <template>
            <el-select
              v-model="rolesSelect"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="Introduzca un rol"
              :remote-method="remoteMethod"
              v-loading="loadingRoles"
            >
              <el-option v-for="rol in roles" :key="rol.id" :label="rol.name" :value="rol.id"></el-option>
            </el-select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </template>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      ref="myModalRef2"
      id="editUserModal"
      title="Editar usuario"
      @ok="btnEditUser(idEdited)"
    >
      <form @submit.prevent="showModal = false">
        <b-form-group label="Teléfono*">
          <b-form-input
            type="number"
            required
            v-model="inputEditPhone"
            v-bind:class="{ 'is-invalid': attemptSubmit && missingEditPhone }"
          ></b-form-input>
          <div class="invalid-feedback">Campo obligatorio</div>
        </b-form-group>
        <b-form-group label="Roles*">
          <template>
            <el-select
              v-model="rolesEditSelect"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="Introduzca un rol"
              :remote-method="remoteMethod"
              v-loading="loadingRoles"
            >
              <el-option v-for="rol in roles" :key="rol.id" :label="rol.name" :value="rol.id"></el-option>
            </el-select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </template>
        </b-form-group>
      </form>
    </b-modal>
    <b-modal
      ref="deleteModalRef"
      id="promptModal"
      title="Borrar usuario"
      @ok="deleteUser(IdDeleted)"
    >
      <form @submit.prevent="showModal = false">
        <p>
          ¿Está seguro que desea borrar el usuario
          <span>{{ this.IdDeleted }}</span>
        </p>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT } from "@/backend";

export default {
  name: "Users",
  components: {},

  data() {
    return {
      showTitle: false,
      currentPage: 1,
      perPage: 60,
      totalRows: 0,
      totalPages: 0,
      loadingUsers: false,
      loadingRoles: false,
      loadingResetSms: false,
      msg: "Usuarios",
      desc: "Gestión de usuarios del BackOffice",
      usuarios: [],
      addUser: [],
      idEdited: "",
      IdDeleted: "",
      inputName: "",
      inputSurname: "",
      inputPhone: "",
      inputBirthdate: "",
      inputEditName: "",
      inputEditSurname: "",
      inputEditPhone: "",
      inputEditBirthdate: "",
      rol: "",
      roles: [],
      rolesSelect: [],
      rolesEditSelect: [],
      attemptSubmit: false,
      sortDir: "desc",
      currentField: "id"
    };
  },
  mounted() {
    this.showTitle = true;
    this.getRoles();
    this.getUsers();
  },
  computed: {
    missingPhone: function() {
      return this.inputPhone === "";
    }
  },
  methods: {
    getRoles() {
      this.loadingRoles = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/roles"
      })
        .then(response => {
          // console.log(response);
          this.loadingRoles = false;
          this.roles = response.data.data.rolesList;
          // console.group("roles");
          // console.log(this.roles);
          // console.groupEnd();
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },

    getUsers(field) {
      if (
        (field === "id" && this.currentField === "id") ||
        (field === "phone" && this.currentField === "phone")
      ) {
        if (this.sortDir === "asc") {
          this.sortDir = "desc";
        } else {
          this.sortDir = "asc";
        }
      }

      if (field !== "" && typeof field !== "undefined") {
        this.currentField = field;
      }

      this.loadingUsers = true;

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/users",
        // y aqui va la ñapa-jaime (cuyos libros empiezan por la pagina 0)
        params: {
          page: this.currentPage - 1,
          sort: this.currentField,
          sortDir: this.sortDir
        }
      })
        .then(response => {
          this.loadingUsers = false;
          this.usuarios = response.data.data.userList;
          // console.group("usuarios:");
          // console.log(this.usuarios);
          // console.groupEnd();
          this.totalRows = response.data.data.totalResults;
          this.perPage = response.data.data.pageSize;
          this.totalPages = response.data.data.totalPages;
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },
    btnAddUser: function(event) {
      event.preventDefault();
      // console.log("addUser");

      var arrayRoles = [];

      for (var k in this.rolesSelect) {
        if (typeof this.rolesSelect[k] !== "function") {
          arrayRoles.push(this.rolesSelect[k]);
        }
      }
      // console.log(arrayRoles);

      this.attemptSubmit = true;

      if (
        this.missingName ||
        this.missingSurname ||
        this.missingPhone ||
        this.missingBirthdate
      )
        return false;

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "post",
        url: "/api/v1/users",
        data: {
          phone: this.inputPhone,
          roles: arrayRoles
        }
      })
        .then(() => {
          this.$refs.myModalRef.hide();
          this.getUsers();
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },
    btnEditUser(id) {
      event.preventDefault();
      // console.log("editUser");

      var arrayRoles = [];

      for (var k in this.rolesEditSelect) {
        if (typeof this.rolesEditSelect[k] !== "function") {
          arrayRoles.push(this.rolesEditSelect[k]);
        }
      }
      // console.log(arrayRoles);
      this.attemptSubmit = true;
      if (this.missingEditPhone) return false;

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "patch",
        url: "/api/v1/users",
        data: {
          id: id,
          phone: this.inputEditPhone,
          roles: arrayRoles
        }
      })
        .then(() => {
          this.getUsers();
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },
    getUserInfo(id) {
      for (var k in this.usuarios) {
        if (typeof this.usuarios[k] !== "function") {
          if (this.usuarios[k].id === id) {
            this.inputEditPhone = this.usuarios[k].phone;
            this.idEdited = this.usuarios[k].id;
            this.rolesEditSelect = [];
            for (var i in this.usuarios[k].rolesList) {
              if (typeof this.usuarios[k].rolesList[i] !== "function") {
                // console.log(this.usuarios[k].rolesList[i]);
                this.rolesEditSelect.push(this.usuarios[k].rolesList[i].id);
              }
            }
          }
        }
      }

      this.$refs.myModalRef2.show();
    },
    resetSMS(phone) {
      // console.log("resetSMS");
      this.loadingResetSms = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/users/reset-sms-counter",
        params: { phone: phone }
      })
        .then(() => {
          this.loadingResetSms = false;
        })
        .catch(error => {
          this.loadingResetSms = false;
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },
    deleteModal(id) {
      this.IdDeleted = id;
      this.$refs.deleteModalRef.show();
    },
    deleteUser(id) {
      // console.log("deleteUser");
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "delete",
        url: "/api/v1/users",
        params: { id: id }
      })
        .then(() => {
          this.getUsers();
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    }
  }
};
</script>

<style lang="scss">
.page-item.active .page-link {
  background-color: #31022a;
  border-color: #31022a;
}

.thead-dark th {
  cursor: pointer;
}
</style>
